export enum DisplayMode {
  LIST = "list",
  HIERARCHY = "hierarchy"
}
